export class InteractionSystem {
  private collectedItems: Set<string> = new Set();
  private interactedTargets: Set<string> = new Set();

  registerCollect(itemId: string): void {
    this.collectedItems.add(itemId);
  }

  registerInteract(targetId: string): void {
    this.interactedTargets.add(targetId);
  }

  getCollectedItems(): Set<string> {
    return this.collectedItems;
  }

  getInteractedTargets(): Set<string> {
    return this.interactedTargets;
  }
}